import {styled} from "@reside/ui";

import {
  Layout,
  FormBoxWrapper,
  HeaderContainer,
} from "../page-admission-welcome/shared/admission-styles";

export {Layout, FormBoxWrapper, HeaderContainer};

// Additional styles specific to verify answers page can be added here
export const Fieldset = styled.fieldset`
  label {
    margin-bottom: ${({theme}) => theme.space[3]}px;
  }
`;
